import { CategoryCoverageDto, CategoryResponseDto } from 'enrollment/queries/useBenefitCategoryQuery/types';
import {
  BenefitPlanDto,
  PlanRiderDto,
} from 'enrollment/queries/useBenefitPlansQuery/types';
import { BenefitRestrictions } from 'enrollment/queries/useRestrictionsQuery/types';
import { LifeEventRestriction } from 'enrollment/utils/LifeEventUtils/Utils';

//taken from ps_spyder. modified types
export const removeBenefitsThatAreRestricted = (
  lifeEventRestrictions: BenefitRestrictions | BenefitRestrictions[],
  orgBenefits: CategoryResponseDto
) => {
  const restrictedOrgBenefitIds: number[] = [];
  orgBenefits.data.benefits.forEach((orgBenefit) => {
    const orgBenefitId = orgBenefit.benefit.org_benefit_id;
    const lifeEventRestriction = new LifeEventRestriction({
      lifeEventRestrictions: lifeEventRestrictions,
      orgBenefit: orgBenefit.benefit,
      currentCoverage: orgBenefit.coverage || undefined,
    });
    if (
      !orgBenefit.coverage &&
      lifeEventRestriction &&
      lifeEventRestriction.canViewOnly
    ) {
      restrictedOrgBenefitIds.push(orgBenefitId);
    }
  });

  const filteredBenefits = orgBenefits.data.benefits.filter(
    (orgBenefits) =>
      restrictedOrgBenefitIds.indexOf(orgBenefits.benefit.org_benefit_id) === -1
  );

  const newOrgBenefits: CategoryResponseDto = {
    ...orgBenefits,
    data: {
      ...orgBenefits.data,
      benefits: filteredBenefits,
    },
  };

  return newOrgBenefits;
};

export const formatDescription = (description: string) => {
  return description?.replace(/(<([^>]+)>)/gi, '');
};

export const replaceFirstSpaceWithDash = (name: string) => {
  return name.replace(' ', '-');
};

export const getPremiumDisplay = (coverage: CategoryCoverageDto | null) => {
  if (!coverage) {
    return '';
  }
  let retval = Number(coverage.req_subscriber_premium);
  coverage.rider_coverages.forEach((rider) => {
    retval += Number(rider.req_subscriber_premium);
  });

  coverage.coverage_lines?.forEach((line) => {
    line.rider_coverage_lines?.forEach((riderLine) => {
      retval += Number(riderLine.req_subscriber_premium);
    });
  });

  return retval;
};

export const showRiderDetails = (coverage: CategoryCoverageDto | null) => {
  return (
    (coverage?.rider_coverages && coverage?.rider_coverages.length > 0) ||
    (coverage?.coverage_lines &&
      coverage?.coverage_lines.some(
        (line) => line.rider_coverage_lines.length > 0
      ))
  );
};

export const getDrawerRiders = (
  coverage: CategoryCoverageDto | null,
  plan?: BenefitPlanDto
) => {
  if (!coverage) {
    return [];
  }

  if (coverage.rider_coverages?.length > 0) {
    if (plan) {
      return (
        plan.org_plan_rider_benefits?.filter((rider) => {
          return coverage.rider_coverages.find(
            (riderCoverage) =>
              riderCoverage.org_benefit_id === rider.org_benefit_id
          );
        }) || []
      );
    } else {
      const createPlans: PlanRiderDto[] = [];
      coverage.rider_coverages.forEach((riderCoverage) => {
        createPlans.push({
          rider_benefit_id: riderCoverage.id,
          benefit_name: riderCoverage.org_benefit,
          benefit_lookup_code: '',
          org_benefit_id: riderCoverage.org_benefit_id,
          elect_with_plan: false,
          display_with_plan: true,
        });
      });
      return createPlans;
    }
  } else if (coverage.coverage_lines) {
    if (plan) {
      return (
        plan?.org_plan_rider_benefits?.filter((rider) => {
          return coverage.coverage_lines?.some((covLine) =>
            covLine.rider_coverage_lines.find(
              (riderLine) => riderLine.org_benefit_id === rider.org_benefit_id
            )
          );
        }) || []
      );
    } else {
      const createPlans: PlanRiderDto[] = [];
      coverage.coverage_lines.forEach((line) => {
        line.rider_coverage_lines.forEach((riderLine) => {
          createPlans.push({
            rider_benefit_id: riderLine.id,
            benefit_name: riderLine.org_benefit,
            benefit_lookup_code: '',
            org_benefit_id: riderLine.org_benefit_id,
            elect_with_plan: false,
            display_with_plan: true,
          });
        });
      });
      return createPlans;
    }
  }
  return [];
};
